export const mapStreamErrorMessages = (errors: string[]): string => {
  if (!errors.length) return 'Данные некорректны';

  return errors.map((error) => {
    switch (error) {
      case 'INVALID_TARGET_URL':
        return 'Неверный URL канала';
      case 'INVALID_KEY':
        return 'Неверный ключ потока';
      case 'NO_CHANNEL_INFO':
        return 'Данный канал не найден';
      case 'ERROR_GET_CHANNEL_INFO':
        return 'Не удалось получить данные о канале';
      default:
        return 'Данные некорректны';
    }
  }).join(', ');
};